export interface ResultsMap {
  [key: string]: {
    [key: string]: {
      speaker: string;
      description: string;
      adjectives: string;
      audios: string[];
    };
  };
}

export const resultsMap: ResultsMap = {
  de: {
    'female-soft': {
      speaker: 'Nela',
      description: 'components.LoversQuiz.ResultsPage.Nela.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Nela.adjectives',
      audios: ['1714', '3351', '721'],
    },
    'female-passionate': {
      speaker: 'Pantea',
      description: 'components.LoversQuiz.ResultsPage.Pantea.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Pantea.adjectives',
      audios: ['3146', '2330', '800'],
    },
    'female-hard': {
      speaker: 'Lorena',
      description: 'components.LoversQuiz.ResultsPage.Lorena.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Lorena.adjectives',
      audios: ['744', '2261', '1300'],
    },
    'male-soft': {
      speaker: 'Emanuel',
      description: 'components.LoversQuiz.ResultsPage.Emanuel.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Emanuel.adjectives',
      audios: ['3463', '3158', '923'],
    },
    'male-passionate': {
      speaker: 'Samuel',
      description: 'components.LoversQuiz.ResultsPage.Samuel.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Samuel.adjectives',
      audios: ['785', '1435', '3062'],
    },
    'male-hard': {
      speaker: 'Raphael',
      description: 'components.LoversQuiz.ResultsPage.Raphael.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Raphael.adjectives',
      audios: ['3425', '3350', '2343'],
    },
    'either-soft': {
      speaker: 'Nela',
      description: 'components.LoversQuiz.ResultsPage.Nela.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Nela.adjectives',
      audios: ['1714', '3351', '721'],
    },
    'either-passionate': {
      speaker: 'Gami',
      description: 'components.LoversQuiz.ResultsPage.Gami.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Gami.adjectives',
      audios: ['3184', '3305', '3308'],
    },
    'either-hard': {
      speaker: 'Raphael',
      description: 'components.LoversQuiz.ResultsPage.Raphael.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Raphael.adjectives',
      audios: ['3425', '3350', '2343'],
    },
  },
  'fr-fr': {
    'female-soft': {
      speaker: 'Daphné',
      description: 'components.LoversQuiz.ResultsPage.Daphne.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Daphne.adjectives',
      audios: ['2412', '3415', '3157'],
    },
    'female-passionate': {
      speaker: 'Diane',
      description: 'components.LoversQuiz.ResultsPage.Diane.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Diane.adjectives',
      audios: ['3394', '2624', '3240'],
    },
    'female-hard': {
      speaker: 'Léa',
      description: 'components.LoversQuiz.ResultsPage.Lea.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Lea.adjectives',
      audios: ['3145', '2659', '2785'],
    },
    'male-soft': {
      speaker: 'Maël',
      description: 'components.LoversQuiz.ResultsPage.Mael.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Mael.adjectives',
      audios: ['2623', '3460', '2496'],
    },
    'male-passionate': {
      speaker: 'Adam',
      description: 'components.LoversQuiz.ResultsPage.Adam.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Adam.adjectives',
      audios: ['2418', '2419', '3132'],
    },
    'male-hard': {
      speaker: 'Sacha',
      description: 'components.LoversQuiz.ResultsPage.Sacha.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Sacha.adjectives',
      audios: ['3088', '3273', '3076'],
    },
    'either-soft': {
      speaker: 'Maël',
      description: 'components.LoversQuiz.ResultsPage.Mael.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Mael.adjectives',
      audios: ['2623', '3460', '2496'],
    },
    'either-passionate': {
      speaker: 'Alix',
      description: 'components.LoversQuiz.ResultsPage.Alix.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Alix.adjectives',
      audios: ['3216', '2436', '2737'],
    },
    'either-hard': {
      speaker: 'Léa',
      description: 'components.LoversQuiz.ResultsPage.Lea.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Lea.adjectives',
      audios: ['3145', '2659', '2785'],
    },
  },
  'en-gb': {
    'female-soft': {
      speaker: 'Grace',
      description: 'components.LoversQuiz.ResultsPage.Grace.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Grace.adjectives',
      audios: ['2675', '1516', '1195'],
    },
    'female-passionate': {
      speaker: 'Ruby',
      description: 'components.LoversQuiz.ResultsPage.Ruby.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Ruby.adjectives',
      audios: ['1931', '1051', '1194'],
    },
    'female-hard': {
      speaker: 'Esme',
      description: 'components.LoversQuiz.ResultsPage.Esme.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Esme.adjectives',
      audios: ['1328', '1105', '1693'],
    },
    'male-soft': {
      speaker: 'Charlie',
      description: 'components.LoversQuiz.ResultsPage.Charlie.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Charlie.adjectives',
      audios: ['1900', '2707', '2111'],
    },
    'male-passionate': {
      speaker: 'James',
      description: 'components.LoversQuiz.ResultsPage.James.description',
      adjectives: 'components.LoversQuiz.ResultsPage.James.adjectives',
      audios: ['3371', '3289', '3188'],
    },
    'male-hard': {
      speaker: 'Jackson',
      description: 'components.LoversQuiz.ResultsPage.Jackson.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Jackson.adjectives',
      audios: ['2098', '2668', '2002'],
    },
    'either-soft': {
      speaker: 'Charlie',
      description: 'components.LoversQuiz.ResultsPage.Charlie.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Charlie.adjectives',
      audios: ['1900', '2707', '2111'],
    },
    'either-passionate': {
      speaker: 'Gami',
      description: 'components.LoversQuiz.ResultsPage.Gami.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Gami.adjectives',
      audios: ['3322', '3299', '3186'],
    },
    'either-hard': {
      speaker: 'Esme',
      description: 'components.LoversQuiz.ResultsPage.Esme.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Esme.adjectives',
      audios: ['1328', '1105', '1693'],
    },
  },
  'en-us': {
    'female-soft': {
      speaker: 'Grace',
      description: 'components.LoversQuiz.ResultsPage.Grace.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Grace.adjectives',
      audios: ['2675', '1516', '1195'],
    },
    'female-passionate': {
      speaker: 'Ruby',
      description: 'components.LoversQuiz.ResultsPage.Ruby.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Ruby.adjectives',
      audios: ['1931', '1051', '1194'],
    },
    'female-hard': {
      speaker: 'Esme',
      description: 'components.LoversQuiz.ResultsPage.Esme.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Esme.adjectives',
      audios: ['1328', '1105', '1693'],
    },
    'male-soft': {
      speaker: 'Charlie',
      description: 'components.LoversQuiz.ResultsPage.Charlie.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Charlie.adjectives',
      audios: ['1900', '2707', '2111'],
    },
    'male-passionate': {
      speaker: 'James',
      description: 'components.LoversQuiz.ResultsPage.James.description',
      adjectives: 'components.LoversQuiz.ResultsPage.James.adjectives',
      audios: ['3371', '3289', '3188'],
    },
    'male-hard': {
      speaker: 'Jackson',
      description: 'components.LoversQuiz.ResultsPage.Jackson.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Jackson.adjectives',
      audios: ['2098', '2668', '2002'],
    },
    'either-soft': {
      speaker: 'Charlie',
      description: 'components.LoversQuiz.ResultsPage.Charlie.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Charlie.adjectives',
      audios: ['1900', '2707', '2111'],
    },
    'either-passionate': {
      speaker: 'Gami',
      description: 'components.LoversQuiz.ResultsPage.Gami.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Gami.adjectives',
      audios: ['3322', '3299', '3186'],
    },
    'either-hard': {
      speaker: 'Esme',
      description: 'components.LoversQuiz.ResultsPage.Esme.description',
      adjectives: 'components.LoversQuiz.ResultsPage.Esme.adjectives',
      audios: ['1328', '1105', '1693'],
    },
  },
};

interface GetResults {
  primaryKey: string;
  secondaryKey: string;
  locale: string;
  resultsMap: ResultsMap;
}

export const getResults = ({
  primaryKey,
  secondaryKey,
  locale,
  resultsMap,
}: GetResults) => {
  const composedKey = `${primaryKey}-${secondaryKey}`;

  const result = resultsMap[locale][composedKey];

  if (result) {
    return result;
  }

  return;
};
